import React, { useState } from 'react';
import MUIDataTable from 'mui-datatables';
import LoadingPageText from '../../common/Loading/LoadingPageText';
import AuditSearchFilters from './AuditSearchFilters';
import AuditDetailsSidePanel from './AuditDetailsSidePanel';
import { useFetchAuditEvents } from '../../../actions/areas/admin/fetchHooks/fetchAudit';
import { eventHandlers } from './auditHandler';
import { tableSettings } from './auditTableSettings';
import { getDateForApi } from '../../../utils/dates';
import globals from '../../../globals/communityGlobals';

export default function AuditPage() {
  document.title = 'Audit';

  const [state, setState] = useState({
    selectedEventTypes: [],
    filterDateFrom: globals.now.subtract(1, 'd'),
    filterDateTo: globals.now,
    pasKey: null,
    currentPage: 1,
    pageSize: 15,
    sortColumn: 'CreatedDate',
    sortDirection: 'desc',
    openSidePanel: false,
    selectedEntry: null,
  });

  const model = {
    eventTypes: state.selectedEventTypes,
    dateFrom: getDateForApi(state.filterDateFrom),
    dateTo: getDateForApi(state.filterDateTo),
    pasKey: state.pasKey,
    pageSize: state.pageSize,
    currentPage: state.currentPage,
    sortColumn: state.sortColumn,
    sortDirection: state.sortDirection,
  };

  const { data, isDataLoading, isTableDataLoading } = useFetchAuditEvents(model, false);

  const events = eventHandlers(state, setState);
  const settings = tableSettings({
    count: data.totalCount,
    page: data.currentPage - 1,
    pageSize: data.pageSize,
    sortColumn: state.sortColumn,
    sortDirection: state.sortDirection,
    eventHandlers: events,
  });

  if (isDataLoading)
    return <LoadingPageText showHeader={false}>Wait a moment while we gather Audit list info...</LoadingPageText>;

  return (
    <React.Fragment>
      <AuditSearchFilters onSubmit={events.onFiltersChange} events={events} isTableDataLoading={isTableDataLoading} />
      <div className="page-content-wrapper">
        <MUIDataTable
          title={settings.name}
          data={data.eventEntries}
          columns={settings.columns}
          options={settings.options}
        />

        {state.openSidePanel && <AuditDetailsSidePanel eventEntry={state.selectedEntry} events={events} />}
      </div>
    </React.Fragment>
  );
}
